import routeHelper from 'components/shared/mixins/routeHelper'
import { mapGetters } from 'vuex'

export default {
    mixins: [ routeHelper ],
    computed: {
        ...mapGetters({
            course: 'Courses/getSingle',
            courseVideo: 'Courses/getCourseVideo',
            singleCollectionCourses: 'CoursesCollections/getSingleCollectionCourses',
            getCourseById: 'Courses/getCourseById',
            microLearningSections: 'MicroLearning/getMicroLearningSections',
            microLearningSection: 'MicroLearning/getMicroLearningSection',
        }),
        currentCourse () {
            return this.collectionAllCourses.find(el => el.id === this.currentCourseId)
        },
        collectionAllCourses () {
            if (this.singleCollectionCourses.length > 0) {
                return this.singleCollectionCourses
                    .map(course => this.getCourseById(course.id))
                    .filter(el => !!el)
            }
            return []
        },
        videoRedirectionNextSectionTitle () {
            const nextSection = this.getNextSection()
            if (!nextSection) { return }
            return nextSection.title
        },
        isMicroLearningCourse () {
            return !!this.course.elements.find(element => element.type === 'section')
        }
    },
    data () {
        return {
            displayVideoRedirectionBox: false,
            videoRedirectionCountdown: 3,
            isCountDownComplete: false
        }
    },
    methods: {
        getNextSection () {
            if (this.isMicroLearningCourse && !this.isCollectionCoursePage) {
                return this.getNextMicroLearningPart()
            } else if (this.isCollectionCoursePage) {
                if (this.isMicroLearningCourse && !this.isLastSection) {
                    return this.getNextMicroLearningPart()
                } else {
                    return this.getNextCollectionPart()
                }
            }
        },
        getNextMicroLearningPart () {
            const currentSectionIndex = this.microLearningSections.map(element => element.elementId)
                .indexOf(this.microLearningSection.elementId)
            const nextSectionIndex = (currentSectionIndex + 1)
            return this.microLearningSections[nextSectionIndex]
        },
        getNextCollectionPart () {
            const thisSectionIndex = this.collectionAllCourses.findIndex(el => el.id === this.course.id)
            const nextSectionIndex = thisSectionIndex + 1
            return this.collectionAllCourses[nextSectionIndex]
        },
        setVideoCountDownVisible () {
            if (!this.getNextSection) { return }
            this.displayVideoRedirectionBox = true
            this.videoRedirectionCountdown = 3
        },
        countDownComplete () {
            this.isCountDownComplete = true
        },
        setRedirection () {
            return this.isCountDownComplete ? this.redirectToNext() : false
        },
        redirectToNext () {
            const nextSection = this.getNextSection()
            if (!nextSection) { return }
            nextSection.autoPlay = 1
            if (this.isMicroLearningCourse && !this.isCollectionCoursePage) {
                this.selectMicroLearningSection(1)
            } else {
                if (this.isMicroLearningCourse && !this.isLastSection) {
                    this.selectMicroLearningSection(1)
                } else {
                    let route = this.getRouteToCourse(nextSection)
                    route = { ...route, query: { autoplay: 1 } }
                    this.$router.push(route)
                }
            }
            this.displayVideoRedirectionBox = false
            this.isCountDownComplete = false
        }
    },
    watch: {
        isCountDownComplete: {
            handler: 'setRedirection'
        }
    }
}
